"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var system_1 = require("@retriever-ui/system");
var react_1 = __importDefault(require("react"));
var Messages_1 = __importDefault(require("../Messages"));
var InputSearchable_1 = __importDefault(require("./Components/inputs/InputSearchable"));
var StaticOptions_1 = __importDefault(require("./Components/options/StaticOptions"));
var Input_1 = __importDefault(require("./Input"));
var select_context_1 = require("./select.context");
var SelectSearchable = function (_a, ref) {
    var props = __rest(_a, []);
    return (react_1.default.createElement(select_context_1.SelectProvider, __assign({}, props),
        react_1.default.createElement(system_1.retriever.div, null,
            react_1.default.createElement(Input_1.default, __assign({}, props, { ref: ref }), function (_a) {
                var contentRef = _a.contentRef;
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(StaticOptions_1.default, null),
                    react_1.default.createElement(InputSearchable_1.default, { contentRef: contentRef })));
            }),
            react_1.default.createElement(Messages_1.default, { warningMessage: props.warningMessage, error: props.error, readOnly: props.readOnly, disabled: props.disabled }))));
};
exports.default = react_1.default.forwardRef(SelectSearchable);
